export const adminFilterOptions = [
  { value: "admin", label: "Admin" },
  { value: "superadmin", label: "Super Admin" },
];

export const bookingFilterOptions = [
  { label: "Completed", value: "Completed" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Upcoming", value: "Upcoming" },
];

export const operatorFilterOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "In Active" },
];

export const couponFilterOptions = [
  { value: "all", label: "Add Filter" },
  { value: "active", label: "Active" },
  { value: "in-active", label: "In Active" },
];

export const settlementFilterByOptions = [
  { label: "All", value: "all" },
  { label: "Vehicle No", value: "vehicle_number" },
  { label: "Phone No", value: "phone_number" },
  { label: "Booking Id", value: "booking_id" },
  { label: "Operator ID", value: "operator_id" },
];

export const transactionFilterByOptions = [
  { label: "Customer Name", value: "customer_name" },
  { label: "Customer ID", value: "customer_id" },
  { label: "Customer Contact", value: "customer_contact" },
  { label: "Transaction ID", value: "transaction_id" },
];
